<img src="/assets/images/illust/no-match.svg" />

<div class="text">
  {{ translateKey | translate }}
</div>
<div class="cta"></div>
